import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, Paper, Typography } from '@mui/material';
import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            height: { xs: 'auto', sm: 'calc(100vh - 80px)' },
            py: 2,
            overflow: 'hidden',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: { xs: '90%', sm: 'auto' },
            }}
          >
            <ErrorIcon color="error" sx={{ fontSize: 60 }} />
            <Typography variant="h5" component="h2" sx={{ marginTop: '20px' }}>
              Oops, something went wrong.
            </Typography>
            <Typography variant="body1" sx={{ marginTop: '10px' }}>
              Our team has been notified, please try again later.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ marginTop: '20px' }}
              onClick={() => {
                window.location.reload();
              }}
            >
              Refresh
            </Button>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
